<template>

  <div v-if="filteredAttributes?.length || product?.description" class="flex flex-col gap-[24px] container-lg text-medium-gray">
    <div>
      <h2 class="mb-[24px] text-heading-2">
        {{ splitTitle(pageTitle)?.first }}
          <span :class="[theme === 'green' && 'text-lime-green ', theme === 'pink' && 'text-hot-pink ', theme === 'amber' && 'text-amber ', theme === 'sky' && 'text-sky-blue ']">
            {{ splitTitle(pageTitle)?.last }}
          </span>
        </h2>
        <!-- Line after subtitle -->
        <div class="w-full h-1 border-b border-light-gray/25">
          <div class="w-[56%] md:w-[19%] h-1" :class="[theme === 'green' && 'bg-lime-green ', theme === 'pink' && 'bg-hot-pink ', theme === 'amber' && 'bg-amber ', theme === 'sky' && 'bg-sky-blue ']">
          </div>
        </div>
    </div>
    <!-- Description -->
    <template v-if="product.description">
      <div v-html="product.description"></div>
    </template><!-- /.single__text -->
    <!-- Technical specification -->
    <template v-if="filteredAttributes.length">
      <h2 class="text-[20px] leading-[24px] font-bold text-medium-gray">
        {{ in18['page_product_technical_specification'] }}
      </h2>
      <table class="table">
        <tr v-for="(attribute, index) in filteredAttributes" :key="index" :class="{ 'row-gray': index % 2 === 1 }">
          <td class="attribute-title" style="width: 40%">{{ attribute.title }}</td>
          <td class="attribute-value font-medium" style="width: 60%">{{ attribute.value }}</td>
        </tr>
      </table>
    </template>
    <!-- PDF -->
     <div v-if="product?.pdf_attachments?.length" class="w-full flex gap-y-2 flex-wrap px-[24px] py-[20px] border border-[#F2F2F2]">
      <template v-for="(attachment, index) in product?.pdf_attachments" :key="index">
        <a :href="attachment.url" target="_blank" class="flex items-center gap-[10px] w-full md:w-auto" :class="[product?.pdf_attachments.length > 2 ? 'grow': 'min-w-1/3']">
          <img src="/shop/images/pdf_icon.svg" class="">
          <span class="text-center">{{ attachment.title }}</span>
        </a>
        <div v-if="index !== product?.pdf_attachments.length - 1" class="w-full h-[1px] md:h-auto md:min-h-[100%] md:w-[1px] bg-light-gray/25 mx-[40px]"></div>
      </template>
     </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue';

const props = defineProps({
  product: {
    type:     Object,
    required: true,
  },
  in18: {
    type:     Object,
    required: true,
  },
  theme: {
    type: String,
    default: 'sky', // Options: green, pink, amber, sky
  },
  pageTitle: {
    type: String,
    required: true,
  },
});

const filteredAttributes = computed(() =>
  props.product.attributes.filter(attribute => attribute.value && attribute.value.trim() !== '')
);

const splitTitle = (string) => {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
};



</script>

<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #F2F2F2;
}

.row-gray {
  background-color: #F8F8F8;
  /* Light gray background for alternate rows */
}

.attribute-title,
.attribute-value {
  padding: 16px 24px;
  color: #333;
  font-size: 16px;
  text-align: left;
}

.table td {
  vertical-align: middle;
}
</style>

